import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function ProductGallerySlider({gallery, preSettings, productLink, handleClickThrough, hit}:any) {
  var settings = preSettings ? preSettings : {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  function handleSlickInteraction() {
    // window.dataLayer.push({ 
    //   event: "hitGallerySwipe",
    //   eventModel: {
    //     objectID: [hit.objectID],
    //   },
    // });
  }

  return (
    <Slider {...settings} onSwipe={handleSlickInteraction}>
        {gallery.map((image, index) => (
          <div
            key={index} 
          >
              {/* <img 
                alt={`${hit?.title} ${ index != 0 ?  `Image - ${index}` : '' }`}
                loading={index === 0 ? "eager" : "lazy"}
                srcSet={`
                  ${window.Shopify.addSizeToImage(image.src, 360)} 360w,
                  ${window.Shopify.addSizeToImage(image.src, 325)} 325w,
                  ${window.Shopify.addSizeToImage(image.src, 280)} 280w,
                  ${window.Shopify.addSizeToImage(image.src, 225)} 225w
                `}
                sizes={`(min-width: 700px) 360px, (min-width: 600px) 325px, (min-width: 500px) 280px, 225px`}
                src={`${window.Shopify.addSizeToImage(
                  image.src,
                  225
                )}`}
              /> */}
              <img 
                alt={`${hit?.title} ${ index != 0 ?  `Image - ${index}` : '' }`}
                loading={index === 0 ? "eager" : "lazy"}
                srcSet={`
                  ${window.Shopify.addSizeToImage(image.src, 800)} 800w,
                  ${window.Shopify.addSizeToImage(image.src, 700)} 700w,
                  ${window.Shopify.addSizeToImage(image.src, 600)} 600w,
                  ${window.Shopify.addSizeToImage(image.src, 500)} 500w
                `}
                sizes={`(min-width: 700px) 800px, (min-width: 600px) 700px, (min-width: 500px) 600px, 500px`}
                src={`${window.Shopify.addSizeToImage(
                  image.src,
                  500
                )}`}
              />
            </div>
        ))}
    </Slider>
  );
}